import React, { useEffect } from 'react'
import { isIOS, isMacOs } from 'react-device-detect'
import {
  Button,
  Result,
  Results,
  ResultIcon,
  ResultInfo,
  NotFoundWrapper,
  NotFoundText,
} from '../../components/MapaOndeUsar/styles'
import Icon from '../../components/Icons'
import { IconContext } from 'react-icons'
import { TiWarningOutline } from 'react-icons/ti'
import { colorBrandPrimary } from '../../global.style'

const resolveIcon = (value) => {
  if (value === 'ESTACIONAMENTO') return 'Estacionamento'
  if (value === 'ABASTECIMENTO') return 'Abastecimento'
  return 'Pedagio'
}

export { resolveIcon }

const getResult = (onClick = function () {}) => (data, index) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  if (!data) return
  let direction = '#'
  if (data.latlong) {
    direction = `https://www.google.com/maps/dir/?api=1&origin=${data.latlong.latitude},${data.latlong.longitude}&destination=${data.location.latitude},${data.location.longitude}`

    if (isMobile) {
      direction =
        isIOS || isMacOs
          ? `http://maps.apple.com/?daddr=(${data.location.latitude},${data.location.longitude})`
          : direction
    }
  }
  return (
    <Result
      className={`result ${data.selected ? 'selected' : ''}`}
      key={`${index}-${data.id}`}
    >
      <ResultIcon className={`${data.distance ? 'asButton' : ''}`}>
        <Icon
          name={resolveIcon(data.category)}
          fill={colorBrandPrimary.marine}
        />
        <strong>{data.distance ? `${data.distance} km` : ''}</strong>
        <span>{data.distance ? 'DISTANTES' : ''}</span>
        {!!data.distance && (
          <Button
            className="active"
            href={direction}
            target={`${data.distance ? '_blank' : ''}`}
          >
            Traçar rota
          </Button>
        )}
      </ResultIcon>
      <ResultInfo className="asButton">
        <div onClick={(e) => onClick(data.location)}>
          <strong>{data.name}</strong>
          <address>
            {data.address.street}, {data.address.number}. {data.address.city} -{' '}
            {data.address.state}
          </address>
        </div>
      </ResultInfo>
    </Result>
  )
}

const ResultList = (props) => {
  const setSelected = (location) => {
    if (props.onSelect) {
      props.onSelect(location)
    }
  }

  useEffect(() => {
    if (props.list) scrollToSelectedResult()
  })

  const scrollToSelectedResult = () => {
    const firstSelectedResult = document.querySelector('.result.selected')
    if (firstSelectedResult) {
      firstSelectedResult.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
        inline: 'start',
        boundary: document.querySelector('.Controls'),
      })
    }
  }

  if (Array.isArray(props.list) && !props.list.length) {
    return (
      <Results>
        <Result>
          <NotFoundWrapper>
            <IconContext.Provider value={{ size: '2.0em' }}>
              <TiWarningOutline />
            </IconContext.Provider>
            <NotFoundText>Nenhum resultado encontrado</NotFoundText>
          </NotFoundWrapper>
        </Result>
      </Results>
    )
  }
  if (Array.isArray(props.list)) {
    return <Results>{props.list.map(getResult(setSelected))}</Results>
  }
  return null
}

export default ResultList
